import React from 'react'
import { Title } from '../title/title.jsx'
import { encodeForURL } from '../../../global/formatters/string-formatter.js'

export const InvestorRetirementPlanLogin = () => {
  return (
    <div className="u-sizeConstrained u-paddingTop12gu u-paddingBottom12gu">
      <div className="u-flex">
        <Title
          text="Log in to your Retirement Plan Accounts"
          mode="medium-line"
          lineColor="u-bgColorBrand"
        />
      </div>

      <div className="u-paddingTop5gu u-gap48 u-flex u-flexJustifyBetween">
        <div className="u-flex u-flexCol u-size6of12 u-flexJustifyBetween">
          <div>
            <Title text={'Plan Participants'} mode="small" />
            <p className="u-marginTop1gu u-marginBottom3gu u-paddingBottom3gu u-sm-paddingBottom0">
              For <span className="u-textBold">employees</span> of companies
              that have established group plans with Columbia Threadneedle
              Investments, including 401(k) , Money Purchase Pension, Profit
              Sharing, SEP and SIMPLE IRA. Log in to view balances, investment
              allocations and performance, and to change allocations or request
              exchanges.
            </p>
          </div>
          <a
            href={encodeForURL(
              'https://retirementsolutions.financialtrans.com/tf/myPLAN/Welcome?cz=80214112012010800'
            )}
            target="_blank"
            rel="noopener noreferrer"
            className="Button Button--secondary u-block u-textUppercase u-paddingHoriz8gu"
            data-analytics={`login--plan-participants`}
          >
            Log In
          </a>
        </div>

        <div className="u-flex u-flexCol u-size6of12 u-flexJustifyBetween">
          <div>
            <Title text={'Plan Sponsors'} mode="small" />
            <p className="u-marginTop1gu u-paddingBottom3gu u-sm-paddingBottom0">
              First-time users: To obtain online access to CPIWeb, please return
              the completed{' '}
              <a href="/content/columbia/pdf/00213013NSB_APPLICATIONCPI_FINAL.PDF">
                Online Access Form
              </a>
              .
            </p>
            <p className="u-paddingBottom3gu u-sm-paddingBottom0">
              For <span className="u-textBold">employers</span> who have
              established group plans with Columbia Threadneedle Investments,
              including 401(k) , Money Purchase Pension, Profit Sharing, SEP and
              SIMPLE IRA. View plan level information and transmit plan
              contributions via CPIWeb.
            </p>
            <p className="u-marginBottom3gu u-paddingBottom3gu u-sm-paddingBottom0">
              To process plan contributions via electronic funds transfer,
              return a completed{' '}
              <a href="/content/columbia/pdf/00212939NSB_PLANACHELECTRONIC_FINAL.PDF">
                ACH Application
              </a>
              . Our <a href="/investor/resources/forms-applications/">Forms</a>{' '}
              area contains other account related forms.
            </p>
          </div>
          <a
            href={encodeForURL(
              'https://retirementsolutions.financialtrans.com/tf/myPLAN/SponsorWelcome?cz=80214112012010800'
            )}
            target="_blank"
            rel="noopener noreferrer"
            className="Button Button--secondary u-block u-textUppercase u-paddingHoriz8gu"
            data-analytics={`login--plan-sponsors`}
          >
            Log In
          </a>
        </div>
      </div>
    </div>
  )
}
